export function shortenByte(num: number | undefined, decimalPlaces = 1): string {
    let str;
    let suffix = '';
    if (!num) {
        return '0B';
    }

    // eslint-disable-next-line no-param-reassign
    decimalPlaces = decimalPlaces || 0;
    // eslint-disable-next-line no-param-reassign
    num = +num.toFixed(decimalPlaces);

    const factor = 10 ** decimalPlaces;

    if (num < 1000) {
        str = num;
        suffix = 'B';
    } else if (num < 1000000) {
        str = Math.floor(num / (1000 / factor)) / factor;
        suffix = 'KB';
    } else if (num < 1000000000) {
        str = Math.floor(num / (1000000 / factor)) / factor;
        suffix = 'MB';
    } else if (num < 1000000000000) {
        str = Math.floor(num / (1000000000 / factor)) / factor;
        suffix = 'GB';
    } else if (num < 1000000000000000) {
        str = Math.floor(num / (1000000000000 / factor)) / factor;
        suffix = 'TB';
    } else if (num < 1000000000000000000) {
        str = Math.floor(num / (1000000000000000 / factor)) / factor;
        suffix = 'PB';
    }
    return str + suffix;
}
